import React from "react";
import { Handle, Position } from "@xyflow/react";
import { cn } from "../../../../lib/utils";

const Start = ({ selected }) => {
  return (
    <div
      className={cn(
        "inline-flex h-6 items-center justify-center gap-1 rounded-3xl bg-[#7d52f3] px-2 py-1",
        selected && "outline-2"
      )}
    >
      <div className="text-sm text-primary-foreground">Begin</div>
      <Handle type="source" position={Position.Right} />
    </div>
  );
};

export default Start;
